// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.pagination-next[data-v-2cc900b3],\nbutton.pagination-previous[data-v-2cc900b3] {\n  padding-left: 10px;\n  padding-right: 10px;\n  background-color: transparent;\n}\n.pagination-link.is-current[data-v-2cc900b3] {\n  background: transparent;\n  border: 0;\n  color: #6f6f6f;\n}", ""]);
// Exports
module.exports = exports;
